import React from 'react';
import { TrackInfo } from '../../hooks/useTrackData';

interface TrackInfoDisplayProps {
  trackInfo: TrackInfo | null;
}

const TrackInfoDisplay: React.FC<TrackInfoDisplayProps> = ({ trackInfo }) => {
  if (!trackInfo) return null;

  return (
    <div className="bg-zinc-900 rounded-lg p-8 mb-12">
      <h2 className="text-2xl font-bold text-white mb-4">{trackInfo.title}</h2>
      <p className="text-gray-400 mb-6">{trackInfo.description}</p>
      <ul className="space-y-3">
        {trackInfo.features.map((feature, index) => (
          <li key={index} className="text-gray-400">• {feature}</li>
        ))}
      </ul>
    </div>
  );
};

export default TrackInfoDisplay;